import React from 'react';
import { useParams, useOutletContext, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { TransparencySettings } from '../components/trip/TransparencySettings';
import { RemindersManager } from '../components/trip/RemindersManager';
import TripGeneralSettings from '../components/TripGeneralSettings';

export default function TripSettings() {
  const { tripId } = useParams();
  const context = useOutletContext();
  const { isOrganizer } = context || {};
  const navigate = useNavigate();
  const { t } = useLanguage();

  if (!isOrganizer) {
    return (
      <div className="text-center py-12">
        <p className="text-slate-500 dark:text-slate-400">
          {t('tripSettings.organizerOnly')}
        </p>
        <Button 
          variant="outline" 
          className="mt-4"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('common.back')}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h2 className="font-heading font-bold text-xl text-slate-900 dark:text-white">
          {t('trips.tripSettings')}
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          {t('tripSettings.description')}
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="space-y-6"
      >
        <TripGeneralSettings tripId={tripId} />
        <TransparencySettings tripId={tripId} />
        <RemindersManager tripId={tripId} />
      </motion.div>
    </div>
  );
}
